module.exports = __webpack_public_path__ + "img/ipgone_page3.67b0de65.png";